import { render, staticRenderFns } from "./userDetailsCard.vue?vue&type=template&id=392eecf1&scoped=true&"
import script from "./userDetailsCard.vue?vue&type=script&lang=js&"
export * from "./userDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./userDetailsCard.vue?vue&type=style&index=0&id=392eecf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392eecf1",
  null
  
)

export default component.exports